/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query"
import { queryOptions, useQuery } from "@tanstack/react-query"

import fetch from "~/backend/axiosClient"
import type {
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "~/backend/axiosClient"

import type {
  FindContactsQueryResponse,
  FindContactsQueryParams,
} from "../types/FindContacts.ts"

export const findContactsQueryKey = (params: FindContactsQueryParams) =>
  [{ url: "/v1/contacts" }, ...(params ? [params] : [])] as const

export type FindContactsQueryKey = ReturnType<typeof findContactsQueryKey>

/**
 * @summary Find contacts
 * {@link /v1/contacts}
 */
export async function findContacts(
  params: FindContactsQueryParams,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    FindContactsQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({ method: "GET", url: `/v1/contacts`, params, ...requestConfig })
  return res
}

export function findContactsQueryOptions(
  params: FindContactsQueryParams,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {}
) {
  const queryKey = findContactsQueryKey(params)
  return queryOptions<
    ResponseConfig<FindContactsQueryResponse>,
    ResponseErrorConfig<Error>,
    ResponseConfig<FindContactsQueryResponse>,
    typeof queryKey
  >({
    enabled: !!params,
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal
      return findContacts(params, config)
    },
  })
}

/**
 * @summary Find contacts
 * {@link /v1/contacts}
 */
export function useFindContacts<
  TData = ResponseConfig<FindContactsQueryResponse>,
  TQueryData = ResponseConfig<FindContactsQueryResponse>,
  TQueryKey extends QueryKey = FindContactsQueryKey,
>(
  params: FindContactsQueryParams,
  options: {
    query?: Partial<
      QueryObserverOptions<
        ResponseConfig<FindContactsQueryResponse>,
        ResponseErrorConfig<Error>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<RequestConfig> & { client?: typeof fetch }
  } = {}
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...queryOptions } = queryConfig
  const queryKey = queryOptions?.queryKey ?? findContactsQueryKey(params)

  const query = useQuery(
    {
      ...findContactsQueryOptions(params, config),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient
  ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey
  }

  query.queryKey = queryKey as TQueryKey

  return query
}
